// extracted by mini-css-extract-plugin
export var gridContainer = "styles-module--gridContainer--gZgyU";
export var heroContainer = "styles-module--heroContainer--eiFkb";
export var asideContainer = "styles-module--asideContainer--j1VXg";
export var contentContainer = "styles-module--contentContainer--DXVpo";
export var navContainer = "styles-module--navContainer--HhVeD";